import { createModel } from "@rematch/core";

import * as api from "../api";
import { RootModel } from ".";
import { checkToken, signoutIfUnauthorized } from "./utilities";

const initialState: Array<{ name: string; uuid: string }> = [];

export const nextBestActivities = createModel<RootModel>()({
  state: initialState,
  reducers: {
    fetchSuccess(
      state,
      payload: { nextBestActivities: Array<{ name: string; uuid: string }> }
    ) {
      return payload.nextBestActivities;
    },
    fetchFail(state) {
      return { ...state };
    },
  },
  effects: (dispatch) => ({
    async fetchNextBestActivities(payload: null, rootState) {
      const token = checkToken(rootState, () =>
        dispatch.nextBestActivities.fetchFail()
      );
      if (!token) return;

      try {
        const nextBestActivitiesResult = await api.fetchNextBestActivities(
          token
        );
        dispatch.nextBestActivities.fetchSuccess(nextBestActivitiesResult.data);
      } catch (error) {
        signoutIfUnauthorized(error, dispatch);
        dispatch.nextBestActivities.fetchFail();
        // eslint-disable-next-line no-console
        console.error(error);
      }
    },
  }),
});



// WEBPACK FOOTER //
// ./src/models/nextBestActivities.ts